export default function getFont(){
  const dmnBookingElement = document.querySelector('#youngs-dmn-booking');

  if(dmnBookingElement.dataset.fontFamily){
    return dmnBookingElement.dataset.fontFamily;
  }

  return `'Nunito Sans', sans-serif`
}
